import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { LocationServiceLocationItem, LocationServiceRecentLocation } from '../../types';

const styles = {
  root: css({
    padding: theme.spacing(2),
    border: `1px solid ${theme.colors.neutral20}`,
    borderRadius: theme.borderRadius.medium,
  }),
  title: css({
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  name: css({
    color: theme.colors.neutral90,
    cursor: 'pointer',
  }),
};
export type SelectLocationCardProps = {
  className?: string;
  location: LocationServiceRecentLocation;

  onRemoveLocation: (locationId: string) => void;
  onChangeLocation: (location: LocationServiceLocationItem) => void;
};
export const SelectLocationCard = ({
  className,
  location,
  onRemoveLocation,
  onChangeLocation,
}: SelectLocationCardProps) => {
  return (
    <div className={classNames('card', className)} css={styles.root}>
      <div className='card__title' css={styles.title}>
        <div>
          <Text size='large' css={styles.name} onClick={() => onChangeLocation(location)}>
            {location.name}
          </Text>
        </div>
        <div>
          <Button
            variant='secondary'
            size='small'
            iconName='x'
            onClick={() => onRemoveLocation(location.locationId)}
          ></Button>
        </div>
      </div>
      <div>
        <Text size='small' color='subdued'>
          {dayjs(location.created).format('MMM DD, YYYY - hh:mm A')}
        </Text>
      </div>
    </div>
  );
};
